import { render, staticRenderFns } from "./OnboardInvites.vue?vue&type=template&id=a43988bc&scoped=true&"
import script from "./OnboardInvites.vue?vue&type=script&lang=js&"
export * from "./OnboardInvites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a43988bc",
  null
  
)

export default component.exports